<div class="center" style="margin:10px">
  <kendo-card [width]="'100%'">
    <kendo-card-header class="k-hbox">
      <div>
        <h1 kendoCardTitle>{{formTitle}}</h1>
      </div>
    </kendo-card-header>
    <kendo-card-body>
      <form>
        <div>

          <div class="form-group">
            <label for="frameName">Frame Name</label>
            <input type="text"
                   class="form-control input-width"
                   id="frameName"
                   [(ngModel)]="frameInEditMode.frameName"
                   name="frameName">

          </div>

          <div class="form-group">
            <label for="frameCodePrefix">Code Prefix</label>
            <input type="text"
                   class="form-control input-width"
                   id="frameCodePrefix"
                   [(ngModel)]="frameInEditMode.framecodePrefix"
                   name="frameCodePefix">
          </div>
          <hr />
          <div class="form-group">
            <label for="frameSelection">Frame Selection</label>
            <div class="row">
              <div class="col-md-6">
                <input type="radio"
                       id="foo" name="a"
                       (checked)="frameInEditMode.haveFrameCode"
                       (change)="frameSelectionChanged(true)" />
                <label class="k-radio-label" for="foo">Frame Code</label>
              </div>
              <div class="col-md-6">
                <input type="radio" id="foo1" name="a"
                       (checked)="frameInEditMode.haveFrameCode"
                       (change)="frameSelectionChanged(false)" />
                <label class="k-radio-label" for="foo1"> Attribute Filter</label>
              </div>
            </div>
            <hr />
            <div *ngIf="frameInEditMode.haveFrameCode">
              <div class="form-group">
                <label for="frameCode">Frame Code</label>
                <input type="text"
                       class="form-control input-width"
                       id="frameCode"
                       [(ngModel)]="frameInEditMode.framecodePrefix"
                       name="frameCode">
              </div>
            </div>
            <div *ngIf="!frameInEditMode.haveFrameCode">
              <div class="form-group">
                <label for="frameAttribute">Attribute Filter</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist class="kendoInput form-control k-width input-width"
                                      id="frameAttribute"
                                      [data]="attributeList"
                                      [(ngModel)]="selectedAttributeName"
                                      [filterable]="true"
                                      textField="name"
                                      valueField="name"
                                      name="frameAttribute"
                                      (filterChange)="attributeFilterChangeHandler($event)"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>
                  <div class="input-group-append">
                    <span class="k-icon k-i-plus k-icon-size form-control"
                          style="color: green;"
                          (click)="addFrameAttribute()"
                          title="Add Attribute"></span>
                  </div>
                </div>
              </div>
              <div class="form-group"
                   *ngFor="let attr of frameInEditMode.attributeFilters;let pAttrIndex=index">
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <button *ngIf="pAttrIndex !== 0" class="k-i-arrow-chevron-right k-icon-size form-control"
                            (click)="moveAttribute(pAttrIndex, 'up')"
                            style="color: black; height: 40px; font-size: 20px"
                            aria-label="Up"
                            [disabled]="isUpDisabled(pAttrIndex)">

                      <!-- Up Arrow -->
                    </button>
                    <button *ngIf="pAttrIndex !== frameInEditMode.attributeFilters.length - 1" class="k-i-arrow-chevron-down k-icon-size form-control"
                            (click)="moveAttribute(pAttrIndex, 'down')"
                            style="color: black; height: 40px; font-size:20px"
                            aria-label="Down"
                            [disabled]="isDownDisabled(pAttrIndex)">

                      <!--Down Arrow-->
                    </button>
                  </div>
                  <input type="text" class="form-control" value="{{attr.name}}" disabled />
                  <div class="input-group-append">
                    <span class="k-icon k-i-minus k-icon-size" style="color: red;"
                          (click)="removeFrameAttribute(pAttrIndex)"
                          title="Delete"></span>
                  </div>
                </div>
              </div>
              <div class="form-group"
                   *ngIf="otherNestedFrameIndex.length>0">
                <label>Copy settings from frame</label>
                <div class="input-group mb-3">
                  <kendo-dropdownlist class="kendoInput form-control k-width input-width"
                                      id="otherFrames"
                                      [data]="otherNestedFrameIndex"
                                      [(ngModel)]="sourceFrameIndex"
                                      name="otherFrames"></kendo-dropdownlist>
                  <div class="input-group-append">
                    <button class="clearKendoButton btn btn-success"
                            (click)="copyFrameSettings()"
                            kendoButton>
                      Copy
                    </button>
                  </div>

                </div>
              </div>
            </div>
            <div *ngIf="currentFrameConfigMode===0 || currentFrameConfigMode===1">
              <div class="form-group">
                <label for="framecodeSuffix">Frame Code Suffix</label>
                <input type="text"
                       class="form-control input-width"
                       id="framecodeSuffix"
                       [(ngModel)]="frameInEditMode.framecodeSuffix"
                       name="framecodeSuffix">
              </div>
            </div>
          </div>
        </div>

      </form>
    </kendo-card-body>
  </kendo-card>
  <button class="m-3 clearKendoButton btn btn-success"
          (click)="saveFrame()"
          kendoButton>
    Save Frame
  </button>
  <button class="m-3 clearKendoButton btn btn-success" (click)="goBack()"
          kendoButton>
    Back
  </button>
  <!--(click)="goBack()"-->
</div>
